import logo from '../../../public/images/logo.png'

export function Header() {
  return (
    <nav className="w-screen h-30 flex items-center justify-center bg-background border-b-2 border-border sm:justify-start sm:pl-10">
      <img src={logo} alt="Logo" width={150} height={60} />
    </nav>
  );
}